import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DamageManagementService } from '../../../../services/damage-management.service';

/**
 * Riquadro "utente collegato" nell'header delle pagine della gestione danni
 * (/damage-management, /damage-overview, /damages-client-overview,
 * /damages-dealer-overview, /damage-overview/assigned e dettaglio pratica): nome e
 * codice dell'utente e i collegamenti alle pagine, con
 * quello della pagina corrente evidenziato. Il bottone "assegnate a me" porta
 * il badge verde con il numero di pratiche aperte in carico all'utente.
 */
@Component({
  selector: 'app-damage-nav-box',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './damage-nav-box.component.html',
  styleUrls: ['./damage-nav-box.component.css']
})
export class DamageNavBoxComponent implements OnInit {
  currentUserName = '';
  currentUserCode = '';
  /** Pratiche aperte assegnate all'utente (null finché non caricato o in errore) */
  assignedCount: number | null = null;
  isLoadingAssignedCount = false;

  constructor(private damageService: DamageManagementService) {}

  ngOnInit(): void {
    this.loadCurrentUser();
    this.refresh();
  }

  private loadCurrentUser(): void {
    const stored = localStorage.getItem('userInfo');
    if (!stored) return;
    try {
      const user = JSON.parse(stored);
      this.currentUserName = (user?.userFullName || user?.userName || '').toString().trim();
      this.currentUserCode = (user?.userName || '').toString().trim();
    } catch {
      // userInfo non leggibile: il riquadro mostra i valori di default
    }
  }

  /** Ricarica il numero di pratiche aperte assegnate all'utente (badge) */
  refresh(): void {
    if (this.isLoadingAssignedCount) return;
    this.isLoadingAssignedCount = true;
    this.damageService.getAssignedDamagesCount().pipe(
      finalize(() => { this.isLoadingAssignedCount = false; })
    ).subscribe({
      next: res => {
        this.assignedCount = res.count;
        if (res.userCode) this.currentUserCode = res.userCode;
      },
      error: () => { this.assignedCount = null; }
    });
  }

  get assignedTitle(): string {
    return this.assignedCount == null
      ? 'Pratiche danno assegnate a me'
      : 'Pratiche danno assegnate a me: ' + this.assignedCount + ' aperte';
  }
}
